import { ReactNode } from 'react';
import { Badge } from '@Components/Badge';
import { Button } from '@Components/Button';
import { ToggleSwitch } from '@Components/ToggleSwitch';
import { Appearance, Size } from '@Components/designConstants';
import { LabelPosition } from '@Components/ToggleSwitch/ToggleSwitch';
import { conditionallyPluralize } from '@src/utils/text-utils';
import { useNotImplemented, useShowWipActions } from '../activity-feed-utils';

interface FilterHeaderProps {
  filterCount: number;
  onClear: () => void;
}

export const FilterHeader = ({ filterCount, onClear }: FilterHeaderProps): ReactNode => {
  const showWip = useShowWipActions();
  const notImplemented = useNotImplemented();

  const filtersOnCopy = `${conditionallyPluralize(filterCount, 'filter')} on`;

  return (
    <div className='activity-feed-filter-header'>
      <div className='activity-feed-filter-header-row'>
        <span className='activity-feed-filter-header-title'>Filters</span>
        {showWip && (
          <ToggleSwitch
            label='Unread-Only'
            labelPosition={LabelPosition.TRAILING}
            checked={false}
            onChange={() => notImplemented()}
            size={Size.SM}
          />
        )}
      </div>
      {filterCount > 0 && (
        <div className='activity-feed-filter-header-meta'>
          <div className='activity-feed-filter-count'>
            <Badge size={Size.SM}>{filterCount}</Badge>
            <span>{filtersOnCopy}</span>
          </div>
          <Button appearance={Appearance.EMPTY} size={Size.SM} onClick={onClear}>
            Clear all
          </Button>
        </div>
      )}
      <div className='activity-feed-filter-divider' />
    </div>
  );
};
